<template>
  <div class="switcher__field">
    <div class="switcher__label">
      <div v-if="hint && floating"
           class="switcher__hint">
        <div class="switcher__icon">
          <vsx-icon color="#1a1a1a"
                    icon-name="InfoCircle"
                    :size="16"
                    type="linear" />
        </div>
        <div class="switcher__floating">
          {{ hint }}
        </div>
      </div>
      <div class="flex flex-col gap-1">
        <p class="text-gray-900 font-medium">{{ label }}</p>
        <span v-if="hint && !floating"
              class="text-gray-300 font-normal">{{ hint }}</span>
      </div>
    </div>
    <div class="switcher__info">
      <span v-if="text"
            class="switcher__text">({{ text }})</span>
      <input-switcher v-model="isSwitcherOpen"
                      :disabled="disabled"
                      size="large" />
    </div>
  </div>
</template>

<script>
  import InputSwitcher from './InputSwitcher.vue';
  export default {
    name: 'SwitcherField',
    components: { InputSwitcher },
    props: {
      label: {
        type: String,
        required: true,
      },
      text: {
        type: String,
        default: '',
      },
      modelValue: {
        type: Boolean,
        default: false,
      },
      hint: {
        type: String,
        required: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      floating: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      isSwitcherOpen: {
        get() {
          return this.modelValue;
        },
        set(value) {
          this.$emit('update:modelValue', value);
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
.switcher {
  &__field {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 48px;
    padding: 10px 16px;
    border-radius: 8px;
    border: 1px solid var(--gray500);
    background-color: var(--shadesWhite);
  }
  &__info {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  &__text {
    font-size: 12px;
    color: var(--gray500);
  }
  &__label {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    color: var(--gray500);
  }
  &__hint {
    position: relative;
    &:hover .switcher__floating {
      display: block;
      z-index: 1;
    }
  }
  &__icon {
    line-height: 0;
  }
  &__floating {
    background: var(--shadesBlack);
    color: var(--shadesWhite);
    padding: 5px;
    border-radius: 8px;
    position: absolute;
    bottom: 100%;
    left: 0;
    width: 200px;
    display: none;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
  }
}
</style>
